<button
  class="accordion__head md:re-items-center re-w-full"
  [attr.data-qa]="shortInfo"
  (click)="isOpen=!isOpen"
  type="button"
  [ngClass]="[ position === 'left' ? 're-justify-start' : 're-justify-end', buttonStyles ]"
  [attr.aria-expanded]="isOpen"
  [attr.aria-controls]="contentId"
  [id]="buttonId"
>
  <ng-content select="[slot=customHeader]"></ng-content>
  @if (!arrowRight) {
    <div class="arrow-icon">
      <bdo-svg [name]="isOpen ? 'icon-edge-arrow-up' : 'icon-edge-arrow-down'" styling="bdo-svg accordion-iconPosition"
      class="icon"></bdo-svg>
    </div>
  }
  <div class="bold">
    {{shortInfo}}
  </div>
  @if (arrowRight) {
    <div class="arrow-icon re-ml-10 re-self-center">
      <bdo-svg [name]="isOpen ? 'icon-edge-arrow-up' : 'icon-edge-arrow-down'" styling="bdo-svg accordion-iconPosition"
      class="icon"></bdo-svg>
    </div>
  }
</button>
@if (isOpen) {
  <div
    class="accordion__content"
    role="region"
    [id]="contentId"
    [attr.aria-labelledby]="buttonId"
  >
    <ng-content></ng-content>
  </div>
}
